module.exports = __webpack_public_path__ + "static/media/hero-img.e8a14fe7.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/hero-img.svg
 ** module id = 777
 ** module chunks = 0
 **/